/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
        {
        header: "Super Admin",
        icon: "PackageIcon",
        i18n: "Super Admin",
        rule: 'admin',
        items: [
            {
                url: "/dashboard-hrm",
                name: "DASHBOARD",
                slug: "dashboard",
                icon: "HomeIcon",
                i18n: "DASHBOARD",
                prefix: '/dashboard-hrm',
                space: 'hrm',
            },
            {
                url: "/dashboard-crm",
                name: "DASHBOARD",
                slug: "dashboard",
                icon: "HomeIcon",
                i18n: "DASHBOARD",
                prefix: '/dashboard-crm',
                space: 'crm',
            },
            {
                url: "/admin/manage-organization",
                name: "Organization",
                slug: "manage-organization",
                icon: "GlobeIcon",
                i18n: "navMenu.organization",
            },
            {
                url: "/admin/manage-camera",
                name: "Camera",
                slug: "admin-manage-camera",
                icon: "CameraIcon",
                i18n: "Organization",
            },
            // {
            //   url: "/admin/manage-master-work-shift",
            //   name: "Ca làm việc",
            //   slug: "manage-master-work-shift",
            //   icon: "GlobeIcon",
            //   rule: 'organization',
            //   i18n: "Organization",
            // },
            {
                url: null,
                name: 'navMenu.servicePack',
                i18n: 'Manage',
                icon: 'PackageIcon',
                rule: 'admin',
                submenu: [
                    {
                        url: "/admin/permission-function",
                        name: "navMenu.funcAuthority",
                        slug: "permission-function",
                        icon: "SidebarIcon",
                        i18n: "navMenu.funcAuthority",
                    },
                    {
                        url: "/admin/organization-package",
                        name: "navMenu.servicePack",
                        slug: "organization-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.servicePack",
                    },
                    {
                        url: "/admin/history-register-package",
                        name: "navMenu.requestHistory",
                        slug: "history-register-package",
                        icon: "PackageIcon",
                        i18n: "navMenu.requestHistory",
                    },
                ]
            },
            {
                url: null,
                name: 'navMenu.manageEmployee',
                i18n: 'navMenu.manageEmployee',
                icon: 'UsersIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manager-employee',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/organization-info",
                        name: "navMenu.organizationInformation",
                        slug: "user-organization-info",
                        icon: "GlobeIcon",
                        i18n: "navMenu.organizationInformation",
                        rule: 'organization_user',
                    },
                    {
                        url: "/apps/email",
                        name: "License",
                        slug: "license",
                        icon: "CreditCardIcon",
                        i18n: "License",
                    },
                    {
                        url: "/user/organization-branch",
                        name: "navMenu.branch",
                        slug: "user-organization-branch",
                        icon: "GitBranchIcon",
                        i18n: "navMenu.branch",
                    },
                    {
                        url: "/user/manage-department",
                        name: "navMenu.department",
                        slug: "user-manage-department",
                        i18n: 'navMenu.department',
                    },
                    {
                        url: "/user/manage-employee",
                        name: "navMenu.personnel",
                        slug: "user-manage-employee",
                        i18n: "navMenu.personnel",
                    },
                    {
                        url: "/user/manage-leave",
                        name: "navMenu.leave",
                        slug: "user-manage-leave",
                        i18n: "navMenu.leave",
                    },
                    {
                        url: "/user/manage-permision",
                        name: "Quản lý quyền",
                        slug: "user-manage-permision",
                        i18n: "navMenu.managePermision",
                    },
                    {
                        url: "/user/manage-position",
                        name: "Quản lý chức vụ",
                        slug: "user-manage-position",
                        i18n: "navMenu.managePosition",
                    }
                    // {
                    //   url: "/user/manage-stranger",
                    //   name: "Phát hiện xâm nhập",
                    //   slug: "manage-report-stranger",
                    //   icon: "FlagIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-crowded",
                    //   name: "Cảnh báo tụ tập",
                    //   slug: "manage-report-crowded",
                    //   icon: "AlertTriangleIcon",
                    //   i18n: "Report",
                    // },
                    // {
                    //   url: "/user/manage-face-id",
                    //   name: "Chấm công Face ID",
                    //   slug: "user-manage-face-id",
                    //   icon: "SmileIcon",
                    //   i18n: "FaceId",
                    // },
                ]
            },
            {
                url: null,
                name: 'navMenu.customerManagement',
                i18n: 'navMenu.customerManagement',
                icon: 'UserPlusIcon',
                rule: 'organization_user',
                prefix: '/user/menu-customer',
                space: 'crm',
                submenu: [
                    {
                        url: "/user/customer-general",
                        name: "navMenu.generalCustomers",
                        slug: "user-customer-general",
                        i18n: "navMenu.generalCustomers",
                    },
                    {
                        url: "/user/potential-customers",
                        name: "navMenu.potentialCustomers",
                        slug: "user-customer-customers",
                        i18n: "navMenu.potentialCustomers",
                    },
                    {
                        url: "/user/opportunistic-customers",
                        name: "navMenu.opportunisticCustomers",
                        slug: "user-opportunistic-customers",
                        i18n: "navMenu.opportunisticCustomers",
                    },
                    {
                        url: "/user/booking-customers",
                        name: "navMenu.bookingCustomers",
                        slug: "user-booking-customers",
                        i18n: "navMenu.bookingCustomers",
                    },
                    {
                        url: "/user/arrive-customers",
                        name: "navMenu.arriveCustomers",
                        slug: "user-arrive-customers",
                        i18n: "navMenu.arriveCustomers",
                    },
                    {
                        url: '/user/consulting-step',
                        name: 'navMenu.consultingStep',
                        slug: 'consulting-step',
                        i18n: 'navMenu.consultingStep',
                    },
                    {
                        url: '/user/fee-collection-step',
                        name: 'navMenu.feeCollectionStep',
                        slug: 'fee-collection-step',
                        i18n: 'navMenu.feeCollectionStep',
                    },
                    {
                        url: '/user/paraclinical-examination-step',
                        name: 'navMenu.paraclinicalExaminationStep',
                        slug: 'paraclinical-examination-step',
                        i18n: 'navMenu.paraclinicalExaminationStep',
                    },
                    {
                        url: '/user/completed-step',
                        name: 'navMenu.completedStep',
                        slug: 'completed-step',
                        i18n: 'navMenu.completedStep',
                    },
                    {
                        url: '/user/feedback',
                        name: 'navMenu.feedback',
                        slug: 'user-feedback',
                        i18n: 'navMenu.feedback',
                        icon: 'MessageSquareIcon',
                        rule: 'organization_user',
                        prefix: '/user/menu-feedback',
                        space: 'crm',
                    },
                    {
                        url: "/user/customer",
                        name: "navMenu.customer",
                        slug: "user-customer",
                        i18n: "navMenu.customer",
                    },
                    {
                        url: "/user/in-out-history-customer-realtime",
                        name: "navMenu.customerIdentification",
                        slug: "user-in-out-history-customer-realtime",
                        icon: "SidebarIcon",
                        i18n: "navMenu.customerIdentification",
                    }
                ]
            },
            // {
            //     url: null,
            //     name: 'navMenu.bookingSchedule',
            //     slug: 'book-schedule',
            //     i18n: 'navMenu.bookingSchedule',
            //     icon: 'CalendarIcon',
            //     rule: 'organization_user',
            //     prefix: '/user/menu-book-schedule',
            //     space: 'crm',
            //     submenu: [
            //         {
            //             url: '/user/booking-schedule',
            //             name: 'Lịch hẹn',
            //             slug: 'book-schedule',
            //             i18n: 'navMenu.appointmentSchedule',
            //         },
            //         {
            //             url: '/user/booking-schedule-history',
            //             name: 'Lịch sử đặt lịch',
            //             slug: 'user-book-schedule-history',
            //             i18n: 'navMenu.bookingScheduleHistory',
            //         }
            //     ]
            // },
            // {
            //     url: null,
            //     name: 'navMenu.medicalExamination',
            //     slug: 'medical-examination-process',
            //     i18n: 'navMenu.medicalExamination',
            //     icon: 'SlackIcon',
            //     rule: 'organization_user',
            //     prefix: '/user/menu-medical-examination-process',
            //     space: 'crm',
            //     submenu: [
            //         {
            //             url: '/user/waiting-for-reception',
            //             name: 'navMenu.waitingForReception',
            //             slug: 'waiting-for-reception',
            //             i18n: 'navMenu.waitingForReception',
            //         },
            //         {
            //             url: '/user/reception-step',
            //             name: 'navMenu.receptionStep',
            //             slug: 'reception-step',
            //             i18n: 'navMenu.receptionStep',
            //         },
            //         {
            //             url: '/user/consulting-step',
            //             name: 'navMenu.consultingStep',
            //             slug: 'consulting-step',
            //             i18n: 'navMenu.consultingStep',
            //         },
            //         {
            //             url: '/user/fee-collection-step',
            //             name: 'navMenu.feeCollectionStep',
            //             slug: 'fee-collection-step',
            //             i18n: 'navMenu.feeCollectionStep',
            //         },
            //         {
            //             url: '/user/paraclinical-examination-step',
            //             name: 'navMenu.paraclinicalExaminationStep',
            //             slug: 'paraclinical-examination-step',
            //             i18n: 'navMenu.paraclinicalExaminationStep',
            //         },
            //         {
            //             url: '/user/completed-step',
            //             name: 'navMenu.completedStep',
            //             slug: 'completed-step',
            //             i18n: 'navMenu.completedStep',
            //         }
            //     ]
            // },
            // {
            //     url: '/user/feedback',
            //     name: 'navMenu.feedback',
            //     slug: 'user-feedback',
            //     i18n: 'navMenu.feedback',
            //     icon: 'MessageSquareIcon',
            //     rule: 'organization_user',
            //     prefix: '/user/menu-feedback',
            //     space: 'crm',
            // },
            {
                url: null,
                name: 'navMenu.servicePacks',
                i18n: 'navMenu.servicePacks',
                icon: 'CodesandboxIcon',
                rule: 'organization_user',
                prefix: '/user/menu-service-packs',
                space: 'crm',
                submenu: [
                    {
                        url: '/user/manage-service-type',
                        name: 'navMenu.manageServiceType',
                        slug: 'user-manage-service-type',
                        i18n: 'navMenu.manageServiceType',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/manage-service-packs',
                        name: 'navMenu.manageServicePacks',
                        slug: 'user-manage-service-packs',
                        i18n: 'navMenu.manageServicePacks',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/manage-service-combo',
                        name: 'navMenu.comboService',
                        slug: 'user-service-combo',
                        i18n: 'navMenu.comboService',
                        rule: 'organization_user',
                    }
                ]
            },
            {
                url: null,
                name: 'navMenu.callCenter',
                i18n: 'navMenu.callCenter',
                icon: 'PhoneCallIcon',
                rule: 'organization_user',
                prefix: '/user/menu-call-center',
                space: 'crm',
                submenu: [
                    {
                        url: "/user/overview-call-center",
                        name: "navMenu.overviewCallCenter",
                        slug: "user-overview-call-center",
                        i18n: "navMenu.overviewCallCenter",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/call-history",
                        name: "navMenu.callHistory",
                        slug: "user-call-history",
                        i18n: "navMenu.callHistory",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/call-monitoring",
                        name: "navMenu.callMonitoring",
                        slug: "user-call-monitoring",
                        i18n: "navMenu.callMonitoring",
                        rule: 'organization_user',
                    },   
                    {
                        url: "/user/active-call",
                        name: "navMenu.activeCall",
                        slug: "user-active-call",
                        i18n: "navMenu.activeCall",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/login-session",
                        name: "navMenu.loginSession",
                        slug: "user-login-session",
                        i18n: "navMenu.loginSession",
                        rule: 'organization_user',
                    },
                    {
                        url: "/user/management-configuration",
                        name: "navMenu.managementConfiguration",
                        slug: "user-management-configuration",
                        i18n: "navMenu.managementConfiguration",
                        rule: 'organization_user',
                    },
            
                 
                ]
            },
            {
                url: null,
                name: 'navMenu.newfeed',
                i18n: 'navMenu.newfeed',
                icon: 'MonitorIcon',
                rule: 'organization_user',
                prefix: '/user/menu-newfeed',
                space: 'crm',
                submenu: [
                    {
                        url: '/user/newfeed',
                        name: 'navMenu.newfeedMenuSub',
                        slug: 'user-newfeed',
                        i18n: 'navMenu.newfeedMenuSub',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/posts-waiting-for-approval',
                        name: 'navMenu.postsWaitingForApproval',
                        slug: 'user-posts-waiting-for-approval',
                        i18n: 'navMenu.postsWaitingForApproval',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/posts-approved',
                        name: 'navMenu.postsApproved',
                        slug: 'user-posts-approved',
                        i18n: 'navMenu.postsApproved',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/posts-rejected',
                        name: 'navMenu.postsRejected',
                        slug: 'user-posts-rejected',
                        i18n: 'navMenu.postsRejected',
                        rule: 'organization_user',
                    },
                    {
                        url: '/user/restricted-keywords',
                        name: 'navMenu.restrictedKeywords',
                        slug: 'user-restricted-keywords',
                        i18n: 'navMenu.restrictedKeywords',
                        rule: 'organization_user',
                    },
                ]
            },

            {
                url: '/user/manage-news-event',
                name: 'navMenu.newEvent',
                slug: 'user-manage-news-event',
                i18n: 'navMenu.newEvent',
                icon: 'AirplayIcon',
                rule: 'organization_user',
                prefix: '/user/menu-news-event',
                space: 'crm',
            },
            {
                url: null,
                name: 'navMenu.care',
                i18n: 'navMenu.care',
                icon: 'AwardIcon',
                rule: 'organization_user',
                prefix: '/user/menu-care',
                space: 'crm',
                submenu: [
                    // {
                    //     url: '/user/manage-care-dashboad',
                    //     name: 'navMenu.careDashboad',
                    //     slug: 'user-manage-care-dashboad',
                    //     icon: '',
                    //     i18n: 'navMenu.careDashboad',
                    //     rule: 'organization_user',
                    // },
                    {
                        url: '/user/manage-care-sms',
                        name: 'navMenu.careSms',
                        slug: 'user-manage-care-sms',
                        i18n: 'navMenu.careSms',
                        rule: 'organization_user',
                    },
                    // {
                    //     url: '/user/manage-care-email',
                    //     name: 'navMenu.careEmail',
                    //     slug: 'user-manage-care-email',
                    //     icon: '',
                    //     i18n: 'navMenu.careEmail',
                    //     rule: 'organization_user',
                    // }
                ]
            },

            {
                url: null,
                name: 'navMenu.resourceManagement',
                i18n: 'navMenu.resourceManagement',
                icon: 'TrelloIcon',
                rule: 'organization_user',
                prefix: '/user/menu-resource',
                space: 'hrm',
                submenu: [{
                    url: "/user/manage-multipurpose-room",
                    name: "navMenu.functionRoom",
                    slug: "user-manage-manage-multipurpose-room",
                    i18n: "navMenu.functionRoom",
                }]
            },
            // {
            //     url: null,
            //     name: 'navMenu.manageCamera',
            //     i18n: 'navMenu.manageCamera',
            //     icon: 'CameraIcon',
            //     rule: 'organization_user',
            //     prefix: '/user/menu-camera',
            //     submenu: [
            // {
            //     url: "/user/stream-camera",
            //     name: "navMenu.stream",
            //     slug: "stream-camera",
            //     icon: "EyeIcon",
            //     i18n: "navMenu.stream",
            // },
            // {
            //     url: "/user/play-back",
            //     name: "navMenu.playBack",
            //     slug: "license",
            //     icon: "FilmIcon",
            //     i18n: "navMenu.playBack",
            // },
            // {
            //     url: "/user/manage-camera",
            //     name: "Camera",
            //     slug: "user-manage-camera",
            //     icon: "CameraIcon",
            //     i18n: "License",
            // },
            // {
            //     url: "/user/manage-camera-layout",
            //     name: "navMenu.listCameras",
            //     slug: "user-manage-camera-layout",
            //     icon: "VideoIcon",
            //     i18n: "navMenu.listCameras",
            // },
            // {
            //     url: "/user/manage-camera-group",
            //     name: "navMenu.groupCamera",
            //     slug: "user-manage-camera-group",
            //     icon: "SettingsIcon",
            //     i18n: "navMenu.groupCamera",
            // },
            // {
            //     url: "/user/manage-event",
            //     name: "navMenu.event",
            //     slug: "user-manage-event",
            //     icon: "ClockIcon",
            //     i18n: "navMenu.event",
            // },
            //     ]
            // },

            // External Device
            // {
            //     url: null,
            //     name: "navMenu.externalDevice",
            //     icon: "RadioIcon",
            //     i18n: "navMenu.externalDevice",
            //     rule: "organization_user",
            //     prefix: '/user/menu-external-device',
            //     submenu: [
            //         {
            //             url: "/user/card-customer",
            //             name: "cardCustomer.magneticCard",
            //             slug: "card-camera",
            //             i18n: "navMenu.cardCustomer",
            //         }
            //     ]
            // },


            // {
            //     url: null,
            //     name: 'navMenu.intelligentHandling',
            //     i18n: 'navMenu.intelligentHandling',
            //     icon: 'EyeIcon',
            //     rule: 'organization_user',
            //     prefix: '/user/menu-ai',
            //     submenu: [
            //         {
            //             url: "/user/face-recognition",
            //             name: "navMenu.faceRecognition",
            //             slug: "face-recognition",
            //             icon: "SmileIcon",
            //             i18n: "navMenu.faceRecognition",
            //         },
            // {
            //     url: '/user/face-recognition-register',
            //     name: "Danh sách đăng kí",
            //     slug: "face-recognition-register",
            //     icon: "ListIcon",
            //     i18n: "License",
            // },
            //         {
            //             url: "/user/ai-restrictedarea",
            //             name: "navMenu.intrusionDetection",
            //             slug: "ai-restrictedarea",
            //             icon: "ListIcon",
            //             i18n: "navMenu.intrusionDetection",
            //             submenu: [
            //                 {
            //                     url: "/user/ai-restrictedarea",
            //                     name: "navMenu.intrusiveSettings",
            //                     slug: "ai-restrictedarea",

            //                     i18n: "navMenu.intrusiveSettings",
            //                 },
            //                 {
            //                     url: "/user/ai-restrictedarea-history",
            //                     name: "navMenu.infiltrationHistory",
            //                     slug: "ai-restrictedarea-history",

            //                     i18n: "navMenu.infiltrationHistory",
            //                 },
            //             ]
            //         },
            //     ]
            // },

            {
                url: null,
                name: 'navMenu.checkIn',
                i18n: 'navMenu.checkIn',
                icon: 'CheckCircleIcon',
                rule: 'organization_user',
                prefix: '/user/menu-manage-wifi',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/manage-wifi",
                        name: "navMenu.wifiCheckIn",
                        slug: "user-manage-wifi",
                        i18n: "navMenu.wifiCheckIn",
                    },
                    {
                        url: "/user/manage-qr-code",
                        name: "navMenu.qrCheckIn",
                        slug: "user-manage-qr-code",
                        i18n: "navMenu.qrCheckIn",
                    },
                    {
                        url: "/user/manage-work-shift-branch",
                        name: "navMenu.shift",
                        slug: "manage-branch-work-shift",
                        i18n: "navMenu.shift",
                    },
                    {
                        url: "/user/manage-work-shift-by-day",
                        name: "navMenu.shiftDaybyday",
                        slug: "manage-work-shift-by-day",
                        i18n: "navMenu.shiftDaybyday",
                    },
                    {
                        url: "/user/over-time-manager",
                        name: "navMenu.workMore",
                        slug: "user-over-time-manager",
                        i18n: "navMenu.workMore",
                    },
                    {
                        url: "/user/time-keeping",
                        name: "navMenu.historyCheckIn",
                        slug: "time-keeping",
                        i18n: "navMenu.historyCheckIn",
                    },
                    {
                        url: "/user/confirm-time-keeping",
                        name: "Xác nhận chấm công",
                        slug: "personnel",
                        i18n: "Organization",
                    },
                    {
                        url: "/user/update-in-out",
                        name: "navMenu.complaintLetter",
                        slug: "update-in-out",
                        i18n: "navMenu.complaintLetter",
                    },
                    {
                        url: "/user/in-out-history",
                        name: "navMenu.historyInOut",
                        slug: "personnel",
                        i18n: "navMenu.historyInOut",
                    }
                ]
            },

            {
                url: null,
                name: 'navMenu.policy',
                i18n: 'navMenu.policy',
                icon: 'BookIcon',
                rule: 'organization_user',
                prefix: '/user/menu-policy',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/manage-policy",
                        name: "policy.leave",
                        slug: "user-manage-policy",
                        i18n: "policy.leave",
                    },
                    {
                        url: "/user/manage-holiday",
                        name: "policy.holiday",
                        slug: "user-manage-holiday",
                        i18n: "policy.holiday",
                    }
                ]
            },

            {
                url: null,
                name: 'navMenu.manageNew',
                i18n: 'navMenu.manageNew',
                icon: 'NavigationIcon',
                rule: 'organization_user',
                prefix: '/user/menu-internal-communications',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/manage-news",
                        name: "navMenu.mNew",
                        slug: "user-manage-news",
                        i18n: "navMenu.mNew",
                    },
                    {
                        url: "/user/manage-notification",
                        name: "navMenu.notification",
                        slug: "user-manage-notification",
                        i18n: "navMenu.notification",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageDevice',
                i18n: 'navMenu.manageDevice',
                icon: 'PackageIcon',
                rule: 'organization_user',
                prefix: '/user/menu-asset',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/manage-device",
                        name: "navMenu.listDevice",
                        slug: "manage-device",
                        i18n: "navMenu.listDevice",
                    },
                    {
                        url: "/user/assign-device-history",
                        name: "navMenu.historyDevice",
                        slug: "assign-device-history",
                        i18n: "navMenu.historyDevice",
                    },
                ]
            },

            {
                url: null,
                name: 'navMenu.manageEquipment',
                i18n: 'navMenu.manageEquipment',
                icon: 'ArchiveIcon',
                rule: 'organization_user',
                prefix: '/user/menu-item',
                space: 'hrm',
                submenu: [
                    {
                        url: "/user/manage-equipment",
                        name: "navMenu.listEquipment",
                        slug: "manage-equipment",
                        icon: "BriefcaseIcon",
                        i18n: "navMenu.listEquipment",
                    },
                    {
                        url: "/user/edit-equipmen",
                        name: "navMenu.editEquipment",
                        slug: "manage-equipment",
                        i18n: "navMenu.editEquipment",
                    },

                    {
                        url: "/user/assign-equipment-history",
                        name: "navMenu.historyEquipment",
                        slug: "assign-equipment-history",
                        i18n: "navMenu.historyEquipment",
                    },
                ]
            },

            {
                url: '/user/workspace-setting',
                name: 'Workspace',
                slug: 'user-workspace-setting',
                icon: 'SettingsIcon',
                rule: 'admin',
                prefix: '/user/menu-workspace-setting',
            },

            {
                url: '/user/setting-crm',
                name: 'navMenu.settings',
                i18n: 'navMenu.settings',
                slug: 'user-setting-crm',
                icon: 'SettingsIcon',
                rule: 'organization_user',
                prefix: '/user/setting-crm',
                space: 'crm',
            },
        ],


    },
]
